// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.scroll-to-top {
  background-color: var(--fs-green);
  width: 40px;
  height: 40px;
  border-radius: 50%;
  position: fixed;
  right: 20px;
  bottom: 20px;
  display: none;
  justify-content: center;
  align-items: center;
}
.scroll-to-top .arrow-icon {
  color: white;
  font-size: 20px;
}

.scroll-to-top:hover {
  cursor: pointer;
}

@media (max-width: 1023px) {
  .scroll-to-top {
    display: flex;
  }
}
/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImFwcC1zY3JvbGwtdG8tdG9wLmNvbXBvbmVudC5zY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0VBQ0UsaUNBQUE7RUFDQSxXQUFBO0VBQ0EsWUFBQTtFQUNBLGtCQUFBO0VBQ0EsZUFBQTtFQUNBLFdBQUE7RUFDQSxZQUFBO0VBQ0EsYUFBQTtFQUNBLHVCQUFBO0VBQ0EsbUJBQUE7QUFDRjtBQUVFO0VBQ0UsWUFBQTtFQUNBLGVBQUE7QUFBSjs7QUFJQTtFQUNFLGVBQUE7QUFERjs7QUFJQTtFQUNJO0lBQ0UsYUFBQTtFQURKO0FBQ0YiLCJmaWxlIjoiYXBwLXNjcm9sbC10by10b3AuY29tcG9uZW50LnNjc3MiLCJzb3VyY2VzQ29udGVudCI6WyIuc2Nyb2xsLXRvLXRvcCB7XG4gIGJhY2tncm91bmQtY29sb3I6IHZhcigtLWZzLWdyZWVuKTtcbiAgd2lkdGg6IDQwcHg7XG4gIGhlaWdodDogNDBweDtcbiAgYm9yZGVyLXJhZGl1czogNTAlO1xuICBwb3NpdGlvbjogZml4ZWQ7XG4gIHJpZ2h0OiAyMHB4O1xuICBib3R0b206IDIwcHg7XG4gIGRpc3BsYXk6IG5vbmU7XG4gIGp1c3RpZnktY29udGVudDogY2VudGVyO1xuICBhbGlnbi1pdGVtczogY2VudGVyO1xuXG5cbiAgLmFycm93LWljb24ge1xuICAgIGNvbG9yOiB3aGl0ZTtcbiAgICBmb250LXNpemU6IDIwcHg7XG4gIH1cbn1cblxuLnNjcm9sbC10by10b3A6aG92ZXIge1xuICBjdXJzb3I6IHBvaW50ZXI7XG59XG5cbkBtZWRpYSAobWF4LXdpZHRoOiAxMDIzcHgpIHtcbiAgICAuc2Nyb2xsLXRvLXRvcCB7XG4gICAgICBkaXNwbGF5OiBmbGV4O1xuICAgIH1cbn0iXX0= */`, "",{"version":3,"sources":["webpack://./src/app/shared/scroll-to-top/app-scroll-to-top.component.scss"],"names":[],"mappings":"AAAA;EACE,iCAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AACF;AAEE;EACE,YAAA;EACA,eAAA;AAAJ;;AAIA;EACE,eAAA;AADF;;AAIA;EACI;IACE,aAAA;EADJ;AACF;AACA,wkCAAwkC","sourcesContent":[".scroll-to-top {\n  background-color: var(--fs-green);\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  position: fixed;\n  right: 20px;\n  bottom: 20px;\n  display: none;\n  justify-content: center;\n  align-items: center;\n\n\n  .arrow-icon {\n    color: white;\n    font-size: 20px;\n  }\n}\n\n.scroll-to-top:hover {\n  cursor: pointer;\n}\n\n@media (max-width: 1023px) {\n    .scroll-to-top {\n      display: flex;\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
